/* For default behavior (only one open at a time):
    <dl class="mt-16 divide-y divide-gray-200" data-controller="accordion">
    <!-- Accordion items -->
  </dl>
 */

/* For allowing multiple open items::
    <dl class="mt-16 divide-y divide-gray-200" data-controller="accordion" data-accordion-allow-multiple>
      <!-- Accordion items -->
    </dl>
 */

import { Controller } from "stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
  static targets = ["item", "content", "expandIcon", "collapseIcon"];

  connect() {
    // Initialize all items as closed
    this.activeItemIds = new Set();

    // Track items that have been viewed
    this.viewedItemIds = new Set();

    // Check for data attribute directly
    this.allowMultiple = this.element.hasAttribute(
      "data-accordion-allow-multiple"
    );
  }

  toggle(event) {
    const item = event.currentTarget.closest("[data-target='accordion.item']");
    const contentId = item.getAttribute("data-content-id");
    const content = this.contentTargets.find((el) => el.id === contentId);
    const expandIcon = item.querySelector(
      "[data-target='accordion.expandIcon']"
    );
    const collapseIcon = item.querySelector(
      "[data-target='accordion.collapseIcon']"
    );

    // If clicking an already open item, close it
    if (this.activeItemIds.has(contentId)) {
      this.closeItem(content, expandIcon, collapseIcon);
      this.activeItemIds.delete(contentId);
    } else {
      // Mark this item as viewed (for the blue chevron)
      this.viewedItemIds.add(contentId);
      this.markAsViewed(expandIcon, collapseIcon);

      // If not allowing multiple open items, close any that are open
      if (!this.allowMultiple) {
        this.closeAllItems(contentId);
      }

      // Open clicked item
      this.openItem(content, expandIcon, collapseIcon);
      this.activeItemIds.add(contentId);
    }
  }

  markAsViewed(expandIcon, collapseIcon) {
    // Add the blue text color to both icons
    expandIcon.classList.add("text-sky-500");
    collapseIcon.classList.add("text-sky-500");
  }

  closeAllItems(exceptId = null) {
    // Close all currently open items except the one being opened
    this.activeItemIds.forEach((id) => {
      if (id !== exceptId) {
        const openContent = this.contentTargets.find((el) => el.id === id);
        const openItem = this.itemTargets.find(
          (el) => el.getAttribute("data-content-id") === id
        );
        const openExpandIcon = openItem.querySelector(
          "[data-target='accordion.expandIcon']"
        );
        const openCollapseIcon = openItem.querySelector(
          "[data-target='accordion.collapseIcon']"
        );

        this.closeItem(openContent, openExpandIcon, openCollapseIcon);
        this.activeItemIds.delete(id);
      }
    });
  }

  openItem(content, expandIcon, collapseIcon) {
    // Remove hidden class
    content.classList.remove("hidden");

    // Use el-transition's enter method
    enter(content);

    // Switch icons
    expandIcon.classList.add("hidden");
    collapseIcon.classList.remove("hidden");
  }

  closeItem(content, expandIcon, collapseIcon) {
    // Use el-transition's leave method and add hidden class when done
    leave(content).then(() => {
      content.classList.add("hidden");
    });

    // Switch icons
    expandIcon.classList.remove("hidden");
    collapseIcon.classList.add("hidden");
  }
}
